<template>
  <div
    style="height: 100%;"
  >
    <div
      :style="{ height }"
      style="overflow: auto; padding: 10px; white-space: pre-wrap; font-size: 12px;"
    >{{ terms }}</div>
  </div>
</template>

<script>
import terms from './terms.js'

export default {
  computed: {
    terms () {
      return this.$renderSmartText(this.$store.state.widget?.settings?.terms || terms)
    },
    height () {
      if (this.$store.getters.requireAcceptTerms) {
        return 'calc(100% - 56px)'
      }
      return '100%'
    }
  }
}
</script>
